import React, { useState } from 'react';
import className from 'classnames';
import {get} from 'lodash';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import Modal from './Modal';
import ModalDelete from './ModalDelete';

const AccessTokenTools = ({
  id,
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const [tokenAction, setTokenAction] = useState()

  function handleRequest() {
    requestCallback(axios.get(`/${gon.currentProvider}/api/access_tokens/${id}/${tokenAction}`))
  }

  function toggleModal() {
    modalSet(!modal)
  }

  function removeExpiration() {
    setTokenAction('remove_expiration')
    modalSet(!modal)
  }

  function setExpiration() {
    setTokenAction('set_expiration')
    modalSet(!modal)
  }

  function revokeToken() {
    setTokenAction('revoke')
    modalSet(!modal)
  }

  function reissueToken() {
    setTokenAction('reissue')
    modalSet(!modal)
  }

  return (
    <React.Fragment>
      <div className="Table Table--post-3">
        <div className="Table__row">
          <div className="Table__col Table__col--th">Field</div>
          <div className="Table__col Table__col--th">Value</div>
        </div>

        <div className="Table__row">
          <div className="Table__col">Expiration</div>
          <div className="Table__col">
            <ul className='Table__ban-temporary'>
              <li className='Table__ban-temporary__li'>
                <a
                  className="Badge"
                  onClick={removeExpiration}
                >
                  Remove expiration
                </a>
              </li>
              <li className='Table__ban-temporary__li'>
                <a
                  className="Badge Badge--orange"
                  onClick={setExpiration}
                >
                  Set expiration
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="Table__row">
          <div className="Table__col">Revocation</div>
          <div className="Table__col">
            <ul className='Table__ban-temporary'>
              <li className='Table__ban-temporary__li'>
                <a
                  className="Badge"
                  onClick={reissueToken}
                >
                  Reissue
                </a>
              </li>

              <li className='Table__ban-temporary__li'>
                <a
                  className="Badge Badge--red"
                  onClick={revokeToken}
                >
                  Revoke
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="Table__row">
          <div className="Table__col">Permanent</div>
          <div className="Table__col">
            <ul className="Table__ban-permanent">
              <li className="Table__ban-permanent__li">
                <ModalDelete
                  type='access_token'
                  id={id}
                />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Modal
        isActive={modal}
        onToggleModal={toggleModal}
      >
        <h3 className='Modal__h3'>Token {id}</h3>

        <div className='Modal__p__wrapper'>
          <p className='Modal__p'>Are you sure you want to perform this action?</p>
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray-light'
            onClick={toggleModal}
          >
            Cancel
          </a>

          <button
            className='Button Button--blue'
            onClick={handleRequest}
            ref={$submitButton}
          >
            Submit
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default AccessTokenTools
